import { useMemo } from "react";

import { FaxDirectorySearchResultItem } from "../Components/Search/FaxDirectorySearchResultItem";
import { DirectoryHealthCareProvider } from "../Models/DirectoryHealthCareProvider";
import { PharmacyProxy } from "../Models/PharmacyProxy";

export const useDefaultDirectorySearchResult = (options: {
    preferredPharmacy?: PharmacyProxy,
    externalConsultants?: DirectoryHealthCareProvider[],
    clinicProviders?: DirectoryHealthCareProvider[]
}): FaxDirectorySearchResultItem[] => useMemo<FaxDirectorySearchResultItem[]>(
    () => [
        ...(options.preferredPharmacy?.hasValue() ? [new FaxDirectorySearchResultItem({ preferredPharmacy: options.preferredPharmacy })] : []),
        ...(options.externalConsultants?.map(p => new FaxDirectorySearchResultItem({ entity: p })) ?? []),
        ...(options.clinicProviders?.map(p => new FaxDirectorySearchResultItem({ entity: p })) ?? [])
    ],
    [options.preferredPharmacy, options.externalConsultants, options.clinicProviders]
);
